import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { theme } from '~/styles/theme';
import { PlayerInfo } from '~/pages';
import { Scrollbar, Spinner } from '~/components';
import images from '~/constants/images';
import { useSelector } from 'react-redux';
import { propTypes, defaultProps } from './propsValidation';
import { NameAndRole } from '../components';
import * as S from '../styles';

export default function GlobalStatistics({
  columns,
  handleClickOnRowRight,
  handleClickOnRowLeft,
  modalContentLeft,
  modalContentRight,
  localTableData,
  visitorTableData,
  handleCloseLeft,
  handleCloseRight,
  selectedMatch,
  modalContentLeftInitial,
  modalContentRightInitial,
  placeholderNumElements,
  isFetching,
  localHeadCoach,
  localSecondCoach,
  visitorHeadCoach,
  visitorSecondCoach,
  tabletMode,
  customTr,
}) {
  const [tab, setTab] = useState('local');
  const { t } = useTranslation();
  const { data: match } = useSelector(state => state.matches.selectedMatch);
  const styleTab = {
    secondaryColor: match?.competitionId === 1 ? theme.coral : theme.turquoise,
    withBorder: tabletMode,
  };
  const homeImage = selectedMatch ? selectedMatch.homeTeam.shieldImageUrl : '';
  const awayImage = selectedMatch ? selectedMatch.awayTeam.shieldImageUrl : '';
  const homeName = selectedMatch ? selectedMatch.homeTeam.nickname : '--';
  const awayName = selectedMatch ? selectedMatch.awayTeam.nickname : '--';

  return (
    <S.ContainerSm>
      <Spinner isOpen={isFetching} isRelative />
      <S.TabsSections
        onChange={({ value }) => setTab(value)}
        value={tab}
        homeName={homeName}
        awayName={awayName}
        tabletMode={tabletMode}
        styleTab={styleTab}
      />
      {tab === 'local' && (
        <S.TableContainerLocal>
          <S.TableGlobalStats
            customTr={customTr}
            isFetching={isFetching}
            placeholderNumElements={placeholderNumElements}
            headerSticky
            header={
              <S.HeaderTableContainer bgColor={theme.light2Opacity}>
                <S.HeaderTable>
                  <S.HeaderTitle>{t('squad')}</S.HeaderTitle>
                </S.HeaderTable>
                <S.CoachSection>
                  {localHeadCoach && (
                    <NameAndRole
                      isFetching={isFetching}
                      image={localHeadCoach.photo || images.personPlaceholder}
                      name={localHeadCoach ? localHeadCoach.nickname : null}
                      rol={localHeadCoach ? localHeadCoach.squadRole : null}
                    />
                  )}
                  {localSecondCoach && (
                    <NameAndRole
                      isFetching={isFetching}
                      image={localSecondCoach.photo || images.personPlaceholder}
                      name={localSecondCoach ? localSecondCoach.nickname : null}
                      rol={localSecondCoach ? localSecondCoach.squadRole : null}
                    />
                  )}
                </S.CoachSection>
              </S.HeaderTableContainer>
            }
            responsiveHeader
            columns={columns()}
            data={localTableData}
            selectedRow={
              modalContentRightInitial
                ? modalContentRightInitial.original.id
                : null
            }
            onRowClick={handleClickOnRowLeft}
            styleOptions={{
              primaryColor: theme.light2Opacity,
              secondaryColor: theme.white,
              textColor: theme.dark,
              fullWidth: true,
            }}
          />
          <S.HeaderInfo isLocal>
            <S.HeaderInfoIcon name="star" color="yellow" size={11} />
            <S.HeaderInfoText>
              <span>{t('signaledPlayersAre')}</span>
              <S.Bold>Top 5</S.Bold>
              <span>{t('inTheCategorySignaled')}</span>
            </S.HeaderInfoText>
          </S.HeaderInfo>
        </S.TableContainerLocal>
      )}
      {tab === 'away' && (
        <S.TableContainerVisitor>
          <S.TableGlobalStatsVisitor
            customTr={customTr}
            isFetching={isFetching}
            placeholderNumElements={placeholderNumElements}
            header={
              <S.HeaderTableContainer bgColor={theme.dark5}>
                <S.HeaderTable>
                  <S.HeaderTitle textColor={theme.white}>
                    {t('squad')}
                  </S.HeaderTitle>
                </S.HeaderTable>
                <S.CoachSection>
                  {visitorHeadCoach && (
                    <NameAndRole
                      fixedColumn
                      isFetching={isFetching}
                      styles={{
                        textColor: theme.white,
                      }}
                      image={visitorHeadCoach.photo || images.personPlaceholder}
                      name={visitorHeadCoach ? visitorHeadCoach.nickname : null}
                      rol={visitorHeadCoach ? visitorHeadCoach.squadRole : null}
                    />
                  )}
                  {visitorSecondCoach && (
                    <NameAndRole
                      isFetching={isFetching}
                      styles={{
                        textColor: theme.white,
                      }}
                      image={
                        visitorSecondCoach.photo || images.personPlaceholder
                      }
                      name={
                        visitorSecondCoach ? visitorSecondCoach.nickname : null
                      }
                      rol={
                        visitorSecondCoach ? visitorSecondCoach.squadRole : null
                      }
                    />
                  )}
                </S.CoachSection>
              </S.HeaderTableContainer>
            }
            responsiveHeader
            columns={columns()}
            data={visitorTableData}
            selectedRow={
              modalContentLeftInitial
                ? modalContentLeftInitial.original.id
                : null
            }
            onRowClick={handleClickOnRowRight}
            styleOptions={{
              primaryColor: theme.dark5,
              secondaryColor: theme.dark4,
              textColor: theme.white,
              fullWidth: true,
            }}
          />
          <S.HeaderInfo>
            <S.HeaderInfoIcon name="star" color="yellow" size={11} />
            <span>{t('signaledPlayersAre')}</span>
            <S.Bold>Top 5</S.Bold>
            <span>{t('inTheCategorySignaled')}</span>
          </S.HeaderInfo>
        </S.TableContainerVisitor>
      )}
      <S.ModalPlayer
        isOpen={modalContentLeftInitial}
        onClose={() => handleCloseLeft(null)}
        zone="left"
      >
        <Scrollbar>
          <PlayerInfo
            value={
              modalContentLeft &&
              modalContentLeftInitial &&
              modalContentLeft.original.id ===
                modalContentLeftInitial.original.id
                ? modalContentLeft
                : modalContentLeftInitial
            }
            onClose={() => handleCloseLeft(null)}
            shield={awayImage}
          />
        </Scrollbar>
      </S.ModalPlayer>
      <S.ModalPlayer
        isOpen={modalContentRightInitial}
        onClose={() => handleCloseRight(null)}
        zone="right"
      >
        <Scrollbar>
          <PlayerInfo
            isLocal
            value={
              modalContentRight &&
              modalContentRightInitial &&
              modalContentRight.original.id ===
                modalContentRightInitial.original.id
                ? modalContentRight
                : modalContentRightInitial
            }
            onClose={() => handleCloseRight(null)}
            shield={homeImage}
          />
        </Scrollbar>
      </S.ModalPlayer>
    </S.ContainerSm>
  );
}

GlobalStatistics.propTypes = propTypes;

GlobalStatistics.defaultProps = defaultProps;
